const getShortPath = () => window.location.pathname.trim().replace(/(.+)(\/)$/, '$1');

export default getShortPath;
